import { ITruckerProfileProps } from 'interfaces/profile.interface';

export const mockedSearchedTrucker: ITruckerProfileProps = {
  trucker: {
    id: 'XYW1',
    uuid: '98a62adf-e608-490c-a7c9-f6ba91172bc9',
    name: 'TESTE FRETE',
    cpf: '02505805270',
    selfieUri:
      'https://fretebras-dev-truckers-profile.s3.us-east-1.amazonaws.com/2023/46075a06-2a9c-441a-9dd5-5862361977ef/documents/64765217e1360.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXKHQPS7ONE4HWG4V%2F20231025%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20231025T183154Z&X-Amz-Expires=900&X-Amz-SignedHeaders=host&x-id=GetObject&X-Amz-Signature=1a566c5458a641e3c231d62cfc9161c43f75a2f0a022aa3b61f70b4f7a2f4006',
    isVip: false,
    inContactList: false,
    phones: [
      {
        ddd: 11,
        number: 992951054,
        hasWhatsapp: true,
      },
      {
        ddd: 51,
        number: 992959054,
        hasWhatsapp: true,
      },
    ],
    address: {
      city: 'Monte Carmelo',
      state: 'MG',
      district: 'CENTRO',
      street: 'RUA DO DEV',
      number: '222',
      complement: 'AP',
      zipCode: '',
    },
    cnh: {
      name: 'EDSON GASPAR DUMMEL',
      category: 'AE',
      expirationDate: 'Mai/2030',
      timeSinceFirstLicense: '13 anos',
    },
    timeSinceCreated: '8 meses',
    mainDestination: {
      city: 'N/A',
      state: 'SP',
    },
    mainProducts: ['adubos ', 'sementes e frutos oleaginosos', 'açúcares e produtos de confeitaria', 'cereais'],
    lastLocation: {
      city: '',
      state: '',
      timeSinceCollected: '',
      hasDistance: false,
      distance: 0,
    },
    bank: {
      name: 'DOCK IP SA',
      number: '301',
      account: {
        type: '',
        document: '02505805270',
        number: '30412420',
        branchNumber: '0001',
        createdAt: '0001-01-01T00:00:00Z',
      },
      pix: [
        {
          type: 'nationalRegistration',
          key: '02505805270',
          status: 'active',
        },
        {
          type: 'nationalRegistration',
          key: '02505805270',
          status: 'active',
        },
      ],
    },
    vehicles: [
      {
        id: 'jXgg',
        tractor: {
          type: 'Truck',
          plate: 'CNW-9068',
        },
        rntrc: '***65348',
        body: [{ name: 'body test', plate: 'AAA-1111' }],
        tracker: 'Não tem rastreador',
        locator: 'Não tem localizador',
        images: [],
      },
    ],
    availability: {
      destination: 'São Paulo',
      isAvailable: true,
      originLocation: 'Curitiba',
      originUF: 'PR',
      locationType: 'city',
    },
  },
  evaluation: {
    grade: 4.4,
    total: 11,
    attributes: [],
  },
  journey: {
    total: 25,
    totalCompanies: 13,
    maxValueTrips: '200000.00',
    averageValueTrips: '200000.00',
  },
  isVerified: true,
  isBlocked: false,
  wasSearchedByCpf: true,
  securityAnalysis: {
    documents: [
      {
        description: 'SELFIE',
        status: 'NÃO APROVADO',
      },
      {
        description: 'CNH',
        status: 'NÃO APROVADO',
      },
      {
        description: 'CPF',
        status: 'APROVADO',
      },
      {
        description: 'ENDEREÇO',
        status: 'APROVADO',
      },
    ],
  },
  lastSearches: {
    totalApprovedSearches: 1,
    lastApprovedDate: '2023-10-10 17:42:27',
    lastFiveApprovedProducts: [''],
    maxApprovedCargoPrice: '',
    lastSearchData: [],
  },
};
